<!--
 * @FileDescription: 往来单位的弹框（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-21（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div>
    <a-modal  v-model="isShowModel" class="payment-model"   :footer="null" :title="title"    @cancel="onCancel" >
       <a-form :form="form">
           <a-row :gutter="24">
               <a-col :md="5" :sm="8">
                   <a-form-item>
                       <a-select  v-decorator="['data1',{ rules: [{ required: false}] },]"
                                  placeholder="请选择仓库"
                                  style="width: 180px"
                       >
                           <a-select-option value="1">
                               杭州店
                           </a-select-option>
                           <a-select-option value="2">
                               上海店
                           </a-select-option>
                       </a-select>
                   </a-form-item>
               </a-col>
               <a-col :md="5" :sm="8">
                   <a-form-item>
                       <a-input v-decorator="['value']" placeholder="请输入商品名称/品牌/型号/规格查询" />
                   </a-form-item>
               </a-col>
               <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
               <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
           </a-row>
       </a-form>
        <a-table :columns="columns"
                 :dataSource="dataSource"
                 :pagination="pagination"
                 :scroll="{y:500 }"
                 bordered>
            <template  slot="operation" slot-scope="text, record, index">
                <a-button class="btn-save-next" @click.stop="onSelect(record,index)">选择</a-button>
            </template>
        </a-table>
    </a-modal>
  </div>
</template>
<script>
import {getPageAccount} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from 'moment';
import pick from 'lodash.pick'
import ACol from "ant-design-vue/es/grid/Col";
export default {
    mixins:[mixins],
    data(){
        return{
            isShowModel:false,
            title:'往来单位',
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 45,
                    align: "center",
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '供应商名称',
                    dataIndex: 'code',
                    key:'code',
                    width:150,
                },
                {
                    title: '供应商类目',
                    dataIndex: 'name',
                    key:'name',
                    width:120,
                },
                {
                    title: '联系人',
                    dataIndex: 'name1',
                    key:'name1',
                    width:120,
                },
                {
                    title: '联系电话',
                    dataIndex: 'name2',
                    key:'name2',
                    width:120,
                },
                {
                    title: '所在区域',
                    dataIndex: 'name3',
                    key:'name3',
                    width:120,
                },
                {
                    title: '',
                    width:130,
                    align:'center',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            dataSource:[
                {
                    code:'6532133',
                    name:'现金',
                },
                {
                    code:'6532133',
                    name:'银行存款',
                },
                {
                    code:'6532133',
                    name:'对公账户',
                },
                {
                    code:'6532133',
                    name:'现金1',
                },
                {
                    code:'6532133',
                    name:'现金1',
                },
                {
                    code:'6532133',
                    name:'现金1',
                },{},{},{},{},{},{},{},{}
            ],
            form: this.$form.createForm(this),
        }
    },
    watch: {

    },
    mounted () {

    },
    created () {

    },
    components: {
        ACol,
        AFormItem
    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        */
        onOpen(index){
            if(index == 1){
                this.isShowModel = true
            }

        },
        onCancel(){
            this.isShowModel = false
            this.isShowModel1 = false
        },
        /**
         * @description: 选择类目（方法描述）
         */
        onSelect(record,index){
            console.log(record,index)
            this.isShowModel = false
            this.$emit('onSelectModel',record,index)
        },
    },

}
</script>
<style lang="scss">
    .payment-model{
        width: 960px !important;
        .ant-modal-body{
            padding: 0 24px 24px;
        }
    }
</style>
<style scoped lang="scss">
    .btn-save-next{
        width: 72px;
    }
</style>
